import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingView from '../LoadingView';
import UserManagerContext from './UserManagerContext';

let isLoggedOut = true;

const SignOut = () => {
  const { t } = useTranslation('components');
  const { signOutRedirect } = useContext(UserManagerContext);

  useEffect(() => {
    // Use state to make sure, the user is only logged out once
    if (isLoggedOut) {
      isLoggedOut = false;
      signOutRedirect();
    }
  }, [signOutRedirect]);

  return (
    <LoadingView
      title={t('UserManager.SignOut.title')}
      message={t('UserManager.SignOut.message')}
    />
  );
};

export default SignOut;
